import { MutableRefObject, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { FC } from 'react';
import { toggleBar } from '../../speechstream/toggleToolbar';
import { useAuth0 } from '@auth0/auth0-react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { setStartPoint } from '../../speechstream/setStartPoint';
import { Toolbar } from 'primereact/toolbar';
import { useAppSelector } from '../../redux/hooks';
import { selectedExitSlipModal } from '../../redux/reducers/exitSlipModalSlice';

interface Props {
  speechStreamStartPoint: MutableRefObject<HTMLDivElement | null>;
}

const Footer: FC<Props> = ({ speechStreamStartPoint }) => {
  const { isAuthenticated } = useAuth0();
  const [loadingSpeechStream, setLoadingSpeechStream] = useState(false);
  const exitSlipModalRedux = useAppSelector(selectedExitSlipModal);

  const op = useRef<OverlayPanel>(null);

  const loadToolbar = async () => {
    if (window.speechstream.domControlTools) {
      return toggleBar();
    }
    setLoadingSpeechStream(true);
    try {
      await window.speechstream.Loader.lateLoad();
      setStartPoint(speechStreamStartPoint.current);
    } catch (err) {
      console.log(err);
    }
    setLoadingSpeechStream(false);
  };

  return (
    <Toolbar
      style={{ zIndex: exitSlipModalRedux ? 3 : 9999 }}
      className="nc_footer tw-left-0 tw-right-0 tw-bottom-0 tw-fixed"
      start={
        isAuthenticated && (
          <div className="tw-flex tw-items-center tw-gap-5">
            <div className="nc_logo">
              <p className="tw-font-atkinson tw-font-bold tw-text-neutral-950">Powered by</p>
              <div className="nc_logo_img"></div>
            </div>
            <div className="tw-hidden md:tw-flex tw-items-center tw-gap-5">
              <Button
                label="Accessibility Tools"
                className="nc_footer_link"
                disabled={loadingSpeechStream}
                text
                rounded
                onClick={() => loadToolbar()}
              />
              <a
                className="nc_footer_link"
                href="https://teachtoone.org/terms-of-use/"
                target="_blank"
                rel="noreferrer"
              >
                Terms & Rules
              </a>
            </div>
          </div>
        )
      }
      end={
        isAuthenticated && (
          <div className="tw-flex md:tw-hidden tw-justify-end tw-items-center tw-gap-5">
            <Button
              type="button"
              icon="pi pi-bars"
              rounded
              link
              onClick={e => op.current?.toggle(e)}
              aria-label="Open footer menu"
            />
            <OverlayPanel ref={op}>
              <div className="tw-flex tw-flex-col tw-gap-5">
                <Button
                  label="Accessibility Tools"
                  className="nc_footer_link"
                  text
                  rounded
                  onClick={() => toggleBar()}
                />
                <a
                  className="nc_footer_link"
                  href="https://teachtoone.org/terms-of-use/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms & Rules
                </a>
              </div>
            </OverlayPanel>
          </div>
        )
      }
    />
  );
};

export default Footer;
